// extracted by mini-css-extract-plugin
export default {"card":"ChannelCard_card__+pk5I","title":"ChannelCard_title__YbF-2","content":"ChannelCard_content__ZQyFt"};